var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCfb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51423 19L2 17.5143V7.48571L3.51423 6H6.16414L7.67838 7.48571V9.71429H5.78558V7.85714H3.89279V17.1429H5.78558V15.2857H7.67838V17.5143L6.16414 19H3.51423Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21442 19V17.1429H9.16081V7.85714H8.21442V6H14.8392V8.78571H12.9464V7.85714H11.0536V11.5714H13.4196V13.4286H11.0536V17.1429H12V19H8.21442Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3752 19V17.1429H16.3216V7.85714H15.3752V6H20.4858L22 7.48571V11.9429L21.4322 12.5L22 13.0571V17.5143L20.4858 19H15.3752ZM18.2144 11.5714H20.1072V7.85714H18.2144V11.5714ZM18.2144 17.1429H20.1072V13.4286H18.2144V17.1429Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfb);
export default __webpack_public_path__ + "static/media/cfb.986ab6a9d5c5e54a6cd0e57cd859bfe4.svg";
export { ForwardRef as ReactComponent };